import React from 'react';
import {StyleSheet, View} from 'react-native';
import {Typography} from 'src/components';
import {colors} from 'src/assets';

export type Props = {
  text: string;
};

const Index: React.FC<Props> = ({text}) => {
  return (
    <View style={styles.container}>
      <Typography variant={'h1'} text={text} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    backgroundColor: colors.white,
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomColor: colors.gray1,
    borderBottomWidth: 1,
  },
});

export default Index;
